import React from 'react';
import {
  Button, Form, Row, Col,
} from 'react-bootstrap';
import Select, { createFilter } from 'react-select';
import { organizeSources } from '../../utils';
import CreatableInputOnly from './CreatableInputOnly';
import useSearch from '../../hooks/useSearch';

const SearchForm = () => {
  const { allSources, formik, resetSearch } = useSearch();

  const selectStyle = {
    option: (base) => ({
      ...base,
      color: '#000',
    }),
    container: (base) => ({
      ...base,
      padding: 0,
      height: 'fit-content',
      zIndex: 4,
      color: '#000',
      fontSize: '.875rem',
    }),
    control: (base) => ({
      ...base,
      borderWidth: 0,
      minHeight: 'fit-content',
      height: 'fit-content',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '31px !important',
    }),
    input: (base) => ({
      ...base,
      height: '21px !important',
      padding: 0,
    }),
    multiValue: (base) => ({
      ...base,
      padding: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      fontSize: '.875rem',
    }),
  };

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Row className="search-fields mb-1">
        <Col xs={12} md={4} lg={3}>
          <Form.Label htmlFor="title" column="sm">Title</Form.Label>
          <Form.Control
            name="title"
            placeholder="Search term in title..."
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.title}
            size="sm"
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <Form.Label htmlFor="body" column="sm">Article Body</Form.Label>
          <Form.Control
            name="body"
            placeholder="Search term in article body..."
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.body}
            size="sm"
          />
        </Col>
        <Col xs={6} md={4} lg={3}>
          <Form.Label htmlFor="from" column="sm">Published From</Form.Label>
          <Form.Control
            type="date"
            name="from"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.from}
            size="sm"
          />
        </Col>
        <Col xs={6} md={4} lg={3}>
          <Form.Label htmlFor="to" column="sm">Published To</Form.Label>
          <Form.Control
            type="date"
            name="to"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.to}
            size="sm"
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <Form.Label column="sm">Keywords</Form.Label>
          <CreatableInputOnly
            onChange={(selected) => {
              formik.setFieldValue('keywords', selected);
            }}
            placeholder="Delimited by space / tab"
            onBlur={formik.handleBlur}
            value={formik.values.keywords}
          />
        </Col>
        <Col xs={12} md={4} lg={3}>
          <Form.Label column="sm">IDs</Form.Label>
          <CreatableInputOnly
            onChange={(selected) => {
              formik.setFieldValue('ids', selected);
            }}
            placeholder="Delimited by space/tab"
            onBlur={formik.handleBlur}
            validate={((value) => /^\d+/.test(value))}
            value={formik.values.ids}
          />
        </Col>
        <Col xs={12} md={9} lg={4}>
          <Form.Label column="sm">Sources</Form.Label>
          <Select
            closeMenuOnSelect={false}
            isMulti
            options={organizeSources(allSources)}
            menuPortalTarget={document.body}
            styles={selectStyle}
            filterOption={createFilter({ ignoreAccents: false })}
            onChange={(selected) => {
              formik.setFieldValue('sources', selected);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.sources}
            maxMenuHeight={400}
          />
        </Col>
        <Col xs={6} md={3} lg={2}>
          <Form.Label column="sm">Marked irrelevant?</Form.Label>
          <Form.Check
            type="checkbox"
            name="markedIrrelevant"
            onChange={() => {
              formik.setFieldValue('markedIrrelevant', !formik.values.markedIrrelevant);
            }}
            checked={formik.values.markedIrrelevant}
          />
        </Col>
      </Row>
      <div id="search-buttons">
        <Button
          variant="info"
          className="ml-2"
          onClick={resetSearch}
        >
          Reset Filters
        </Button>
        <Button
          variant="success"
          type="submit"
        >
          Search
        </Button>
      </div>
    </Form>
  );
};

export default SearchForm;
